import ServiceInquiry from './ServiceInquiry';
export default ServiceInquiry;
